import { currentTermsOfService } from '../../config.json';

const mutation = /* GraphQL */ `
  mutation PayReservationMutation($input: PayReservationInput!) {
    payReservation(input: $input) {
      reservation {
        payment {
          quoteRequested
          billingAddress {
            name
            line1
            line2
            city
            state
            postalCode
            country
            phone
          }
          source {
            brand
            last4
            expMonth
            expYear
            tokenizationMethod
          }
        }
      }
    }
  }
`;

function commit(environment, reservationId, payment) {
  return environment.commitMutation(mutation, {
    input: {
      reservationId,
      ecommVersion: __VERSION__,
      termsVersion: `/terms-of-service/${currentTermsOfService}`,
      ...payment,
    },
  });
}

export default { commit };
